export default __webpack_public_path__ + "static/media/photo--lg--112.bb7f71e3.jpg";